import { useEffect, useState, useContext, useRef } from "react";
import SlideContainer from "components/container/SlideContainer";
import Reveal from "reveal.js";
import Markdown from "reveal.js/plugin/markdown/markdown.esm.js";
import _ from "lodash";
// import { WebSocketContext } from "contexts/WebSocketContextProvider";
import { sendSocketMessage } from 'config/socket/socketUtil'


type ILPMainProps = {
  ilpProps: {
    student: { id: string; name: string };
    teacher: { id: string; name: string };
    isTeacher: boolean;
  };
  firebaseRef: any;
  // prevLessonFirebaseRef: any;
  firebaseStorage: any;
  iframeProps: any;
  currentLecture: string;
  socketInstance: any;
  studentNickNameRef: any;
};


function ILPMain({ ilpProps, firebaseRef, firebaseStorage, iframeProps, currentLecture, socketInstance, studentNickNameRef }: ILPMainProps) {
  // const {socket, className, studentId} = useContext(WebSocketContext)
  const slideIndexRef = useRef(0);
  const localStorageSlideIndexRef = useRef(0);
  const isOptionalActivitySkippedRef = useRef(false);
  
  let isTeacher = ilpProps.isTeacher;
  const [currentState, setCurrentState] = useState({
    currentSlideIndex: 0,
    selectedAvatar: 'pirate',
    selectedAvatarStyle: '',
    selectedAccessories: [],
    selectedAnimal: '',
    wickOutputUrl: "",
    studentOutputVideoUrl: "",
    studentOutputGifUrl: "",
    videoUrl: "",
    videoPoster: "",
    isVideoProcessing: false,
  });

  const [slideIndexNumber, setSlideIndexNumber] = useState<number>(0);

  // const [prevLessonData, setPrevLessonData] = useState({})

  const [studentNickName, setStudentNickName] = useState({
    nickName:{
      name: '',
      isFinal: false
    }
  });

  let currentSlide = 0;

  useEffect(() => {
    Reveal.initialize({
      plugins: [Markdown],
      controls: isTeacher ? true : false,
      slideNumber: false,
      progress: false,
      width: 960,
      height: 600,
      controlsBackArrows: "faded",
      navigationMode: "linear",
      mouseWheel: false,
      keyboard: isTeacher ? true : false, // Set this to enable/disable navigation for students
    }).then(() => {
      revealEventHandler();
    });
  }, [isTeacher]);

  useEffect(() => {
    firebaseRef.get().then((docSnapshot: { exists: any, data: () => any }) => {
      if (!docSnapshot.exists) {
        firebaseRef.set({ createdAt: Date.now(), ...currentState });
      }

       let remoteData = docSnapshot.data()
       if(remoteData && "currentSlideIndex" in remoteData){
        Reveal.slide(remoteData.currentSlideIndex)
      }
    });

    studentNickNameRef.get().then((docSnapshot: { exists: any, data: () => any }) =>{
      if (!docSnapshot.exists) {
        studentNickNameRef.set({ ...studentNickName });
      } else {
        const nickName = docSnapshot.data();
        if(!_.isEmpty(nickName)) {
          setStudentNickName({
            nickName: {
              name: nickName.name || '',
              isFinal: nickName.isFinal || false
            }
          })
        }
      }
    });

    window.onbeforeunload = function(e:any) {
      firebaseRef?.update({
        currentSlideIndex: slideIndexRef.current
      });     
      };
  }, []);



  useEffect(() => {
    // If there is some tat data need to be fetched from previous lesson presentation
    // Flow should be
    // 1. Sync Prev data
    // 2. Sync current class data
    // 3. Add Listener
    // If not followed in proper order, all these being async operation, will lead to state mismatch.
    let unsubscribe: any
    let unsubscribeNickName: any

    // **** USE THIS IF THERE IS ANY DEPENDENCY ON PREV LECTURE TO GET THE RELEVANT DATA ****

    // prevLessonFirebaseRef.get().then((docSnapshot: { exists: any, data: () => any }) => {
    //  const prevData = docSnapshot.data()
    //  if (prevData?.selectedCharacter) {
    //   setPrevLessonData({
    //     selectedTheme: prevData.selectedTheme,
    //     selectedCharacter: prevData.selectedCharacter,
    //     characterName: prevData.characterName.name
    //   })
    //  }
    // }).then(() => {
    //   firebaseRef.get().then((docSnapshot: { exists: any, data: () => any }) => {
    //     const currentClassData = docSnapshot.data()

    //     if (currentClassData) {
    //       delete currentClassData.createdAt;
    //     } 

    //     setCurrentState(_.isEmpty(currentClassData) ? currentState : currentClassData);
    //   })
    // }).then(() => {
    //   unsubscribe = firebaseRef?.onSnapshot((doc: { data: () => any }) => {
    //     const remoteData = doc.data();

    //     if (remoteData) {
    //       delete remoteData.createdAt;
    //     } 

    //     setCurrentState(_.isEmpty(remoteData) ? currentState : remoteData);
    //   });
    // });

    // *** USE THIS IF NO DEPENDENCY ON PREVIOUS LECTURE ***
    firebaseRef.get().then((docSnapshot: { exists: any, data: () => any }) => {
      const currentClassData = docSnapshot.data()

      if (currentClassData) {
        delete currentClassData.createdAt;
      } 

      setCurrentState(_.isEmpty(currentClassData) ? currentState : currentClassData);
    }).then(() => {
      unsubscribe = firebaseRef?.onSnapshot((doc: { data: () => any }) => {
        const remoteData = doc.data();

        if (remoteData) {
          delete remoteData.createdAt;
        } 

        if(_.isEmpty(remoteData)) {
          setCurrentState(currentState)
        } else {
          const newState = {
            currentSlideIndex: remoteData.currentSlideIndex || 0,
            selectedAvatar: remoteData.selectedAvatar || 'pirate',
            selectedAvatarStyle: remoteData.selectedAvatarStyle || '',
            selectedAccessories: remoteData.selectedAccessories || [],
            selectedAnimal: remoteData.selectedAnimal || '',
            wickOutputUrl: remoteData.wickOutputUrl || "",
            studentOutputVideoUrl: remoteData.studentOutputVideoUrl || "",
            videoUrl: remoteData.videoUrl || "",
            videoPoster: remoteData.videoUrl || "",
            isVideoProcessing: remoteData.isVideoProcessing || false,
            studentOutputGifUrl: remoteData.studentOutputGifUrl || ''
          }
          setCurrentState(newState)
        }
      });
    });

    unsubscribeNickName = studentNickNameRef?.onSnapshot((doc: { data: () => any }) => {
      const remoteData = doc.data();
      setStudentNickName(_.isEmpty(remoteData) ? studentNickName : remoteData);
    });

    return function(){  
      unsubscribe()
      unsubscribeNickName()
    }
  }, []);

  // useEffect(() => {
  //   let unsubscribe = firebaseRef?.onSnapshot((doc: { data: () => any }) => {
  //     const remoteData = doc.data();

  //     if (remoteData) {
  //       delete remoteData.createdAt;
  //     } 

  //     if(_.isEmpty(remoteData)) {
  //       setCurrentState(currentState)
  //     } else {
  //       const newState = {
  //         currentSlideIndex: remoteData.currentSlideIndex || 0,
  //         selectedAvatar: remoteData.selectedAvatar || 'pirate',
  //         selectedAvatarStyle: remoteData.selectedAvatarStyle || '',
  //         selectedAccessories: remoteData.selectedAccessories || [],
  //         selectedAnimal: remoteData.selectedAnimal || '',
  //         wickOutputUrl: remoteData.wickOutputUrl || "",
  //         studentOutputVideoUrl: remoteData.studentOutputVideoUrl || "",
  //         videoUrl: remoteData.videoUrl || "",
  //         videoPoster: remoteData.videoUrl || "",
  //         isVideoProcessing: remoteData.isVideoProcessing || false,
  //         studentOutputGifUrl: remoteData.studentOutputGifUrl || ''
  //       }
  //       setCurrentState(newState)
  //     }
  //     // setCurrentState(_.isEmpty(remoteData) ? currentState : remoteData);
  //   });

  //   return function(){  
  //     unsubscribe()
  //   }
  // }, [])

  useEffect(() => {
    const callbackFunction = (state: any) => {
      setTimeout(() => {
        Reveal.off("slidechanged", revealSlideChangeCallBack)
        Reveal.slide(state.currentSlide)
        Reveal.on("slidechanged", revealSlideChangeCallBack)
      },100)  
      setSlideIndexNumber(state.currentSlide);
      slideIndexRef.current = state.currentSlide
    }

    socketInstance.onMessage('slidechanged', callbackFunction)
  },[])

  const revealSlideChangeCallBack = () => {
    let currentRate = Reveal.getProgress(); // current slide progress rate wrt total slides
    let total = Reveal.getTotalSlides();

    let rightArrow = document.getElementsByClassName('navigate-right')[0]
    let leftArrow = document.getElementsByClassName('navigate-left')[0]

    rightArrow.classList.add("fadeAndBack");
    leftArrow.classList.add("fadeAndBack");
    Reveal.configure({ keyboard: false });

    setTimeout(() => {
      rightArrow.classList.remove("fadeAndBack")
      leftArrow.classList.remove("fadeAndBack");
      Reveal.configure({ keyboard: isTeacher ? true : false });
    }, 1000)

    currentSlide = Math.floor(currentRate * total);
    if (currentSlide > total - 1) {
      currentSlide = total - 1;
    }

    if (socketInstance.connected) {
      if (currentSlide === 23 && isOptionalActivitySkippedRef.current) {
        if ((currentSlide - localStorageSlideIndexRef.current) === -1 ) {
          currentSlide = 20
          Reveal.slide(currentSlide)
        }
      }
      localStorageSlideIndexRef.current = currentSlide
      firebaseRef.update({ currentSlideIndex: currentSlide });
      sendSocketMessage({ state: { currentSlide }, action: 'slidechanged'})
      setSlideIndexNumber(currentSlide);
      slideIndexRef.current = currentSlide
    }
  }

  const revealEventHandler = () => {
    Reveal.on("slidechanged", revealSlideChangeCallBack)
  };

  return (
    <SlideContainer
      firebaseRef={firebaseRef}
      firebaseStorage={firebaseStorage}
      isTeacher={isTeacher}
      currentState={currentState}
      // prevLessonData={prevLessonData}
      student={ilpProps.student}
      teacher={ilpProps.teacher}
      iframeProps={iframeProps}
      slideIndex={slideIndexNumber}
      socketInstance={socketInstance}
      studentNickName={studentNickName}
      studentNickNameRef={studentNickNameRef}
      isOptionalActivitySkippedRef={isOptionalActivitySkippedRef}
    />
  );
}

export default ILPMain;
